import React, { CSSProperties, FC } from 'react'

import cn from 'classnames'

import classes from './color-button.module.scss'
import renderLinkType from '../../utils/renderLink'

type ButtonProps = {
  ariaLabel?: string
  centered?: boolean
  color?: string
  children?: React.ReactNode
  customStyle?: CSSProperties
  className?: string
  eventName?: string
  eventProductId?: string
  eventCheckoutType?: string
  foreColor?: string
  /* takes the width of the parent element */
  fullWidth?: boolean
  /* 384px max width */
  wide?: boolean
  href?: string
  linkStyle?: boolean
  newTab?: boolean
  onClick?: React.MouseEventHandler
  to?: string
  level?: string
  custStyle?: boolean
  [key: string]: unknown
}

const ColorButton: FC<ButtonProps> = ({
  href,
  to,
  color,
  foreColor,
  children,
  onClick,
  ariaLabel,
  fullWidth = false,
  wide = false,
  linkStyle = false,
  centered = false,
  newTab,
  className,
  customStyle,
  level = 'primary',
  eventName,
  eventProductId,
  eventCheckoutType,
  custStyle,
  ...props
}) => {
  const Component = renderLinkType({ href, to }) as React.ElementType

  const inlineStyle: CSSProperties = {
    ...(foreColor ? { color: foreColor } : {}),
    ...(color && level !== 'tertiary' && !linkStyle
      ? { background: color }
      : {}),
    ...customStyle,
  }

  return (
    <Component
      className={cn(
        classes.button,
        'button',
        level === 'tertiary' && classes.tertiary,
        linkStyle && classes.linkStyle,
        centered && classes.centered,
        wide && !fullWidth && classes.wide,
        fullWidth && classes.fullWidth,
        custStyle && classes.custStyle,
        className
      )}
      style={Object.keys(inlineStyle).length > 0 ? inlineStyle : undefined}
      data-dmpg-event-name={eventName ?? undefined}
      data-event_product_id={eventProductId ?? undefined}
      data-event_checkout-type={eventCheckoutType ?? undefined}
      onClick={onClick}
      href={href}
      to={to}
      aria-label={ariaLabel}
      {...props}
      {...(newTab
        ? {
            target: '_blank',
            rel: 'noopener noreferrer',
          }
        : {})}
    >
      {children}
    </Component>
  )
}

export default ColorButton
